import { render, staticRenderFns } from "./InhouseWaitList.vue?vue&type=template&id=4ef0f1b0"
import script from "./InhouseWaitList.vue?vue&type=script&lang=js"
export * from "./InhouseWaitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports